import React from "react";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import { Center } from "../Center";
import ScaffoldTitle from "../Scaffold/components/ScaffoldTitle";
import Scaffold from "../Scaffold/Scaffold";

interface Props {
  onClickGoBack: () => void;
}

const PatientNotExistScreen = (props: Props) => {
  return (
    <Scaffold
      title={<ScaffoldTitle label={translate(STRINGS.PATIENT_NOT_FOUND)} />}
      onClickGoBack={props.onClickGoBack}
    >
      <Center>
        <div
          style={{
            margin: 32,
            textAlign: "center",
          }}
        >
          {translate(STRINGS.PATIENT_NOT_FOUND_EXPLAIN)}
        </div>
      </Center>
    </Scaffold>
  );
};

export default React.memo(PatientNotExistScreen);
